import React, { useState } from "react";
import CommonModal from "./CommonModal";
import AssignTableModal from "./AssignTableModal";
import EditBookingModal from "./EditBookingModal";

const STATUS_STYLES = {
  0: { label: "Rejected", color: "#dc3545" }, //  laal
  1: { label: "Pending", color: "#ffc107" },  // peela
  2: { label: "Accepted", color: "#28a745" }, // hara
  3: { label: "Completed", color: "#007bff" }, // neela
  4: { label: "No Show", color: "#fd7e14" } // orange
};

const ReservationDetailModal = ({
  isOpen,
  onCancel,
  onConfirm,
  onReject,
  onCancelReservation,
  onProfile,
  onNoShow,
  onClearNoShows,
  onReminder,
  onAssignTable,
  onSendVouchers,
  eventData,
  refreshCalendar
}) => {
  const [isAssignTableOpen, setIsAssignTableOpen] = useState(false);
  const [isEditOpen, setIsEditOpen] = useState(false);
  if (!eventData) return null;

  const {
    customer,
    phone,
    time,
    guests,
    type,
    title,
    assignedTable,
    status,
    noShowCount,
    id
  } = eventData;

  const statusInfo = STATUS_STYLES[status] || STATUS_STYLES[1];


  const isAccepted = status == 2;
  const isRejected = status == 0;
  const isNoShow = status == 4;

   
   const handleAssignTableClick = () => setIsAssignTableOpen(true);

   const handleBackFromAssign = () => setIsAssignTableOpen(false);
 
   const handleSelectTable = (tableNumber) => {
     console.log("Selected Table:", tableNumber);
   };

  return (
    <>
    <CommonModal isOpen={isOpen} onClose={onCancel} elId="cmBookingModal">
      <div className="modal-header">
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={onCancel}
        ></button>
      </div>

      <div className="modal-body">
        <div className="mdUser">
          <span>
            <svg
              width="55"
              height="55"
              viewBox="0 0 55 55"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="27.5" cy="27.5" r="27" fill="#777" />
            </svg>
          </span>
          <span>{customer}</span>
        </div>

        
        <div className="mdAddress">
          <span>{title}</span>
          <span>{phone}</span>
          <span>{time}</span>
          <span>{guests} Person</span>
          <span>{type}</span>
          {assignedTable && <span>Table: {assignedTable}</span>}
        </div>

        
        <div
          className="bookingStatus mt-3 text-center"
          style={{
            fontWeight: 600,
            color: statusInfo.color,
          }}
        >
          Status: {statusInfo.label}
        </div>

        {noShowCount > 0 && (
          <div
            className="mt-2 text-center"
            style={{
              color: "#fd7e14",
              fontWeight: 600,
              fontSize: "14px",
            }}
          >
            ⚠ {noShowCount} previous no-show{noShowCount > 1 ? "s" : ""} for this phone number
            <button
              type="button"
              onClick={onClearNoShows}
              style={{
                marginLeft: "8px",
                background: "none",
                border: "none",
                color: "#adb5bd",
                textDecoration: "underline",
                fontSize: "12px",
                cursor: "pointer",
              }}
            >
              Clear
            </button>
          </div>
        )}


        <div className="modalBodyStyle mt-3">
          <div className="btnGroup justify-content-center tableFilterBtns flex-wrap">

            <button
              type="button"
              className={`radioBtn ${isAccepted ? "active" : ""}`}
              id="acceptBtn"
              onClick={() => !isAccepted && onConfirm()}
              disabled={isAccepted}
              style={{
                backgroundColor: isAccepted ? "#28a745" : "",
                color: isAccepted ? "#fff" : "",
                border: isAccepted ? "1px solid #28a745" : "",
              }}
            >
              <div className="btnText">{isAccepted ? "Accepted" : "Accept"}</div>
            </button>
            <button
              type="button"
              className={`radioBtn ${isRejected ? "active" : ""}`}
              id="rejectBtn"
              onClick={() => !isRejected && onReject()}
              disabled={isRejected}
              style={{
                backgroundColor: isRejected ? "#dc3545" : "",
                color: isRejected ? "#fff" : "",
                border: isRejected ? "1px solid #dc3545" : "",
              }}
            >
              <div className="btnText">{isRejected ? "Rejected" : "Reject"}</div>
            </button>

            <button
              type="button"
              className={`radioBtn ${isRejected ? "active" : ""}`}
              id="cancelBtn"
              onClick={() => !isRejected && onCancelReservation()}
              disabled={isRejected}
              style={{
                backgroundColor: isRejected ? "#6c757d" : "",
                color: isRejected ? "#fff" : "",
                border: isRejected ? "1px solid #6c757d" : "",
              }}
            >
              <div className="btnText">{isRejected ? "Cancelled" : "Cancel"}</div>
            </button>
            
            <button type="button" className="radioBtn" id="profileBtn" onClick={onProfile}>
              <span className="btnText">Profile</span>
            </button>


            <button
              type="button"
              className={`radioBtn ${isNoShow ? "active" : ""}`}
              id="noShowBtn"
              onClick={() => !isNoShow && onNoShow()}
              disabled={isNoShow}
              style={{
                backgroundColor: isNoShow ? "#fd7e14" : "",
                color: isNoShow ? "#fff" : "",
                border: isNoShow ? "1px solid #fd7e14" : "",
              }}
            >
              <span className="btnText">{isNoShow ? "No Show" : "Mark No Show"}</span>
            </button>

            
            <button
              type="button"
              className="radioBtn"
              id="reminderBtn"
              onClick={onReminder}
              disabled={!isAccepted}
              title={!isAccepted ? "Only accepted bookings can be sent a reminder" : ""}
              style={!isAccepted ? { color: "#888", cursor: "not-allowed" } : {}}
            >
              <span className="btnText">Send Reminder</span>
            </button>

            
            <button type="button" className="radioBtn" id="editBookingBtn" onClick={() => setIsEditOpen(true)}>
              <span className="btnText">Edit Booking</span>
            </button>

            
            <button type="button" className="radioBtn" id="assignTableBtn"  onClick={handleAssignTableClick}>
              <span className="btnText">Assign Table</span>
            </button>

            
            <button
              type="button"
              className="radioBtn"
              id="sendVouchersBtn"
              onClick={onSendVouchers}
              disabled={true} 
              style={{color: "#888", cursor: "not-allowed" }}
            >
              <span className="btnText">Send Vouchers</span>
            </button>
          </div>
        </div>
      </div>
    </CommonModal>
    <AssignTableModal
    isOpen={isAssignTableOpen}
    onClose={onCancel}
    onBack={handleBackFromAssign}
    assignedTable={assignedTable}
    onSelectTable={handleSelectTable}
    bookingId={id}
    guests={guests}
    onAssigned={() => {
      refreshCalendar();
      setIsAssignTableOpen(false);
    }}
  />
  <EditBookingModal
    isOpen={isEditOpen}
    onClose={() => setIsEditOpen(false)}
    reservationId={id}
    onUpdated={() => {
      refreshCalendar();
      setIsEditOpen(false);
    }}
  />
  </>
  );
};

export default ReservationDetailModal;
